import AvailableQuantity from '../../../../components/buybox/quantity/quantity.mobile';

import availableQuantity from './available-quantity';

export default availableQuantity(AvailableQuantity);
